import { render, staticRenderFns } from "./komplexbridge.vue?vue&type=template&id=56564952"
import script from "./komplexbridge.vue?vue&type=script&lang=js"
export * from "./komplexbridge.vue?vue&type=script&lang=js"
import style0 from "./komplexbridge.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/komplexbridge.vue
// module id = Xp0R
// module chunks = 0